import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P6-E1",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page6/E1/1.jpg" }]],
  },
  2: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P6-E2",
    audio: "",
    video: "",
    component: UI,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page6/E2/1.jpg" }]],
  },
  3: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P6-E3",
    audio: "img/FriendsPlus/Page6/Audio/audio-e3-p6.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        { url: 'img/FriendsPlus/Page6/E3/1.jpg' },
				{ url: 'img/FriendsPlus/Page6/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page6/Audio/tieude-e3-p6.mp3' },
				{ url: 'img/FriendsPlus/Page6/E3/3.jpg' },
      ],
      [{ url: "img/FriendsPlus/Page6/E3/4.jpg" }]
    ],
  },
  4: {
    // Exercise num
    unit: "Starter",
    id: "SB3-S-P6-E4",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page6/E4/1.jpg" }]],
  },
};

export default json;
